module.exports = __webpack_public_path__ + "static/media/share-green.21da610c.svg";